import { render, staticRenderFns } from "./CompanyAttachments.vue?vue&type=template&id=2a15bf2b&"
import script from "./CompanyAttachments.vue?vue&type=script&lang=js&"
export * from "./CompanyAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports